<ion-tabs [environmentInjector]="environmentInjector"></ion-tabs>